import {
  call,
  fork,
  takeLatest,
  put,
} from 'redux-saga/effects';
import {
  ANALYTICS_SET_ID,
  ANALYTICS_SET_USER_PROPERTIES,
  ANALYTICS_SEND_EVENT,
  GA_SEND_EVENT,
} from '@/action-types/analytics';
import {
  APP_START,
} from '@/action-types/app';
import {
  LOGIN_LOGOUT_REQUEST,
} from '@/action-types/login';
import {
  init,
  setId,
  setUserProperties,
  sendEvent,
  removeUser,
} from '@/services/amplitude';

import utils from '@/utils/auth';

export function* amplitudeSendEvent(params: {
  eventName: string;
  data: any;
}) {
  const rolesData = utils.getUserRole();
  const data = {
    ...(params.data || {}),
    ...rolesData,
  };

  yield fork(sendEvent, params.eventName, data);
}

export function* amplitudeSetId(params: { id: string; }) {
  yield fork(setId, params.id);
}

export function* amplitudeSetUserProperties(data) {
  yield fork(setUserProperties, data);
}

export function* amplitudeInit() {
  const token = yield call(utils.getAccessToken);

  // @ts-ignore
  yield fork(init);

  if (token) {
    const user = yield call(utils.parseToken, token);

    yield put({
      type: ANALYTICS_SET_ID,
      id: user.uid,
    });
    yield put({
      type: ANALYTICS_SET_USER_PROPERTIES,
      data: { role: user.role },
    });
  }
}

export function* amplitudeRemoveUser() {
  yield put({ type: ANALYTICS_SEND_EVENT, eventName: 'logout' });
  yield fork(removeUser);
}

export function gaSendAnalytics(params: {
  eventName: string;
  data: {};
}) {
  try {
    // @ts-ignore
    if (dataLayer) {
      // @ts-ignore
      dataLayer.push(
        {
          event: params.eventName,
          ...(params.data || {}),
        },
      );
    }
  } catch (e) {
    // GTM is not working
  }
}

export default function* app() {
  yield takeLatest(APP_START, amplitudeInit);
  // @ts-ignore
  yield takeLatest(ANALYTICS_SET_ID, amplitudeSetId);
  yield takeLatest(ANALYTICS_SET_USER_PROPERTIES, amplitudeSetUserProperties);
  // @ts-ignore
  yield takeLatest(ANALYTICS_SEND_EVENT, amplitudeSendEvent);
  yield takeLatest(LOGIN_LOGOUT_REQUEST, amplitudeRemoveUser);
  // @ts-ignore
  yield takeLatest(GA_SEND_EVENT, gaSendAnalytics);
}
